import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as tasksReducer from "containers/Tasks/TasksReducer";
import * as projectReducer from "containers/Project/reducer";

import ExploreTask from "components/Tasks/ExploreTask";

const getTaskId = (props) =>
  props && props.taskId
    ? props.taskId
    : props && props.match && props.match.params && props.match.params.taskId
      ? props.match.params.taskId
      : "new";

class TaskContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.init();
  }

  render() {
    const { id } = this.props;

    return <ExploreTask {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const taskId = getTaskId(ownProps);

  return {
    init: () => dispatch(tasksReducer.init(taskId)),
    editFeedback: (id, node, edits) => dispatch(nextReducer.editFeedback(id, node, edits)),
    deleteFeedback: (id, node, edits) => dispatch(nextReducer.deleteFeedback(id, node, edits))
  };
};

const mapStateToProps = (state, ownProps) => {
  const taskId = getTaskId(ownProps);
  const task = tasksReducer.getTask(state, taskId);

  const nextId = task?.versions?.[0]?.data?.nextId;
  const datasetId = nextReducer.getDatasetId(state, nextId);
  const projectId = task?.projects?.[0]?.id;

  const otherProjectId = nextReducer.getProjectId(state, nextId);

  return {
    task: task,
    datasetId: datasetId,
    projectId: projectId,
    exploreAssign: {},
    exploreComments: {},
    dataset: homeReducer.getDataset(state, datasetId),
    isLoadingProject: otherProjectId === undefined ? false : projectReducer.getIsLoadingProject(state, projectId),
    isExploreReady: homeReducer.getIsExploreReady(state, datasetId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TaskContainer);
